var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n\n<p>\n  <button class=\"btn btn-primary btn-md add-officer\">Add Officer</button>\n</p>\n<form class=\"officers-container\"></form>\n\n\n\n";
},"useData":true});